import {
	core,
	useGetAwParserQuery,
	useGetCsvPreprocessorQuery,
	useGetCsvUnzipperQuery,
	useGetDictionaryGeneratorsQuery,
	useGetExtractImportersQuery,
	useGetFilesPreprocessorQuery,
	useGetFileUnzipperQuery,
	useGetInputImporterPDFQuery,
	useGetInputImporterQuery,
	useGetOutputCsvGeneratorsQuery,
	useGetOutputDataGeneratorsQuery,
	useGetCsvUploaderQuery,
	useGetFileUploaderQuery,
	useGetOriginalFileUploaderQuery,
} from "etl/core";
import { getDirectStatus, ProcessorMetaData } from "etl/types";
import { ProcessRunningModalProps, defaultProps } from "./ProcessRunningModal.type";
import styles from "./ProcessRunningModal.module.scss";
import { Spinner } from "../../Atoms";
import { Title, TitleTag, TitleColor } from "design-system/src/Atoms";
import { Fragment } from "react";

export const ProcessRunningModal = (props: ProcessRunningModalProps) => {
	const { ...attributes } = { ...defaultProps, ...props };

	const { selectedEtlImport, selectedEtlImportUuid } = core.useEtlDataSelectors();

	const { data: csvUnzipper = [] } = useGetCsvUnzipperQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: fileUnzipper = [] } = useGetFileUnzipperQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: csvPreprocessor = [] } = useGetCsvPreprocessorQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: filesPreprocessor = [] } = useGetFilesPreprocessorQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: inputImporter = [] } = useGetInputImporterQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: inputImporterPDF = [] } = useGetInputImporterPDFQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: extractImporters = [] } = useGetExtractImportersQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: dictionaryGenerators = [] } = useGetDictionaryGeneratorsQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: outputDataGenerators = [] } = useGetOutputDataGeneratorsQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: outputCsvGenerators = [] } = useGetOutputCsvGeneratorsQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: csvUploaders = [] } = useGetCsvUploaderQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: fileUploaders = [] } = useGetFileUploaderQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: originalFileUploaders = [] } = useGetOriginalFileUploaderQuery({ uuid: selectedEtlImportUuid ?? "" });
	const { data: awParser = [] } = useGetAwParserQuery({ uuid: selectedEtlImportUuid ?? "" });

	if (!selectedEtlImport) return <></>;

	return (
		<div {...attributes} className={styles.ProcessRunningModal}>
			<Title tag={TitleTag.H2} color={TitleColor.Green} content="Process en cours" />

			<div style={{ display: "flex", flexDirection: "column", gap: "1rem", flexWrap: "wrap", maxWidth: "100%", justifyContent: "center" }}>
				{[
					...csvUnzipper,
					...fileUnzipper,
					...csvPreprocessor,
					...filesPreprocessor,
					...inputImporter,
					...inputImporterPDF,
					...extractImporters,
					...dictionaryGenerators,
					...outputDataGenerators,
					...outputCsvGenerators,
					...awParser,
					...csvUploaders,
					...fileUploaders,
					...originalFileUploaders
				].map((item, index) => (
					item.oneByLaboratory ? (
						<Fragment key={item.baseClassName + index}>
							{Object.entries(item.metaData as Record<string, ProcessorMetaData>).map(([laboratory, meta]) =>
								meta.status === "running" ? (
									<div key={`${item.baseClassName}-${laboratory}`} style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem", whiteSpace: "nowrap" }}>
										<Spinner />
										<div>Le traitement de l'étape {item.label} est en cours pour le laboratoire {laboratory}</div>
									</div>
								) : null
							)}
						</Fragment>
					) : (
						<Fragment key={item.baseClassName + index}>
							{getDirectStatus(item) === "running" && (
								<div key={item.baseClassName} style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem", whiteSpace: "nowrap" }}>
									<Spinner />
									<div>Le traitement de {item.label} est en cours</div>
								</div>
							)}
						</Fragment>
					)
				))}
			</div>
		</div>
	)
}
